/* ============================================================
   RideCast - scripts propios (sin librerias externas)
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Solo escondemos cosas si este script se esta ejecutando de verdad.
  document.documentElement.classList.add('rd-anim');

  function initReveal() {
    var items = document.querySelectorAll('.rd-reveal:not(.rd-visible)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('rd-visible');
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var delay = parseInt(el.getAttribute('data-rd-delay') || '0', 10);
        setTimeout(function () { el.classList.add('rd-visible'); }, delay);
        obs.unobserve(el);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    for (var j = 0; j < items.length; j++) obs.observe(items[j]);

    setTimeout(function () {
      var faltan = document.querySelectorAll('.rd-reveal:not(.rd-visible)');
      for (var k = 0; k < faltan.length; k++) faltan[k].classList.add('rd-visible');
    }, 3500);
  }

  /* ---------- Galeria ---------- */
  function initGallery() {
    var galerias = document.querySelectorAll('[data-rd-gallery]');
    if (!galerias.length) return;

    Array.prototype.forEach.call(galerias, function (g) {
      var slides = g.querySelectorAll('[data-rd-slide]');
      var thumbs = g.querySelectorAll('[data-rd-thumb]');
      if (!slides.length || !thumbs.length) return;

      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.getAttribute('data-rd-thumb');
          Array.prototype.forEach.call(slides, function (s) {
            var activa = s.getAttribute('data-rd-slide') === idx;
            s.classList.toggle('is-active', activa);
            var v = s.querySelector('video');
            if (v && !activa && typeof v.pause === 'function') v.pause();
          });
          Array.prototype.forEach.call(thumbs, function (o) { o.classList.toggle('is-active', o === thumb); });
        });
      });
    });
  }

  /* ---------- Variantes (tamaño de pantalla) ---------- */
  function initVariants() {
    var bloques = document.querySelectorAll('[data-rd-variants]');
    if (!bloques.length) return;

    Array.prototype.forEach.call(bloques, function (bloque) {
      var inputs = bloque.querySelectorAll('[data-rd-variant]');
      if (!inputs.length) return;

      var idField = bloque.querySelector('[data-rd-variant-id]');
      var priceEl = bloque.querySelector('[data-rd-price]');
      var compareEl = bloque.querySelector('[data-rd-compare]');
      var stockEl = bloque.querySelector('[data-rd-stock]');
      var boton = bloque.querySelector('[data-rd-add]');
      var agotado = bloque.getAttribute('data-sold-out') || 'Sold out';
      var textoAdd = boton ? (boton.getAttribute('data-default-text') || boton.textContent.trim()) : '';

      function aplicar(input) {
        if (idField) idField.value = input.value;

        var precio = input.getAttribute('data-price') || '';
        var compare = input.getAttribute('data-compare') || '';
        var disponible = input.getAttribute('data-available') === 'true';

        if (priceEl) priceEl.textContent = precio;
        if (compareEl) { compareEl.textContent = compare; compareEl.hidden = compare === ''; }

        if (stockEl) {
          stockEl.classList.toggle('is-out', !disponible);
          var txt = stockEl.querySelector('[data-rd-stock-text]');
          if (txt) txt.textContent = disponible ? (stockEl.getAttribute('data-in-text') || 'In stock') : (stockEl.getAttribute('data-out-text') || 'Out of stock');
        }

        if (boton) {
          boton.disabled = !disponible;
          boton.textContent = disponible ? textoAdd : agotado;
        }

        Array.prototype.forEach.call(inputs, function (otro) {
          var label = otro.closest('.rd-pdp__opt');
          if (label) label.classList.toggle('is-active', otro === input);
        });
      }

      Array.prototype.forEach.call(inputs, function (input) {
        input.addEventListener('change', function () { if (input.checked) aplicar(input); });
      });

      var marcado = bloque.querySelector('[data-rd-variant]:checked');
      if (marcado) aplicar(marcado);
    });
  }

  /* ---------- Cantidad ---------- */
  function initCantidad() {
    var grupos = document.querySelectorAll('[data-rd-qty]');
    if (!grupos.length) return;

    Array.prototype.forEach.call(grupos, function (grupo) {
      var input = grupo.querySelector('input');
      var menos = grupo.querySelector('[data-rd-qty-menos]');
      var mas = grupo.querySelector('[data-rd-qty-mas]');
      if (!input) return;

      function cambiar(paso) {
        var v = parseInt(input.value, 10);
        if (isNaN(v)) v = 1;
        input.value = Math.max(1, Math.min(99, v + paso));
      }

      if (menos) menos.addEventListener('click', function () { cambiar(-1); });
      if (mas) mas.addEventListener('click', function () { cambiar(1); });
      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        input.value = isNaN(v) ? 1 : Math.max(1, Math.min(99, v));
      });
    });
  }

  function init() {
    initReveal();
    initGallery();
    initVariants();
    initCantidad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) initReveal(); });
})();
